import '../css/app.css';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { initializeTheme } from './hooks/use-appearance';
import React, { useEffect } from 'react';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

const ThemeObserver: React.FC = () => {
    useEffect(() => {
        const htmlElement = document.documentElement;

        // `dark` クラスが既に存在しない場合にのみ追加
        if (!htmlElement.classList.contains('dark')) {
            htmlElement.classList.add('dark');
        }

        // MutationObserver を設定
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                // `class` 属性が変更されたことを監視
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    // `dark` クラスが削除された場合、再度追加
                    if (!htmlElement.classList.contains('dark')) {
                        htmlElement.classList.add('dark');
                    }
                }
            }
        }
        );

        // `<html>` 要素の `class` 属性の変更を監視開始
        observer.observe(htmlElement, { attributes: true, attributeFilter: ['class'] });

        // コンポーネントがアンマウントされたときにオブザーバーを停止
        return () => observer.disconnect();
    }, []); // 空の依存配列で、コンポーネントがマウントされたときに一度だけ実行

    return null; // このコンポーネントはUIをレンダリングしないので null を返す
};

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./pages/${name}.tsx`, import.meta.glob('./pages/**/*.tsx')),
    setup({ el, App, props }) {
        const root = createRoot(el);
        <ThemeObserver />
        root.render(<App {...props} />);
    },
    progress: {
        color: '#4B5563',
    },
});

// This will set light / dark mode on load...
initializeTheme();
